import React from 'react';

export default function SelectToolTip() {
  return (
    <div className="tooltiptext">Add/Remove Expenses</div>
  );
}
